import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUsers,
  updateUserStatus
} from "../../services/userService";
import { toast } from "react-toastify";

const initialState = {
  users: [],
  total:0,
  page:0,
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Fetch all users
export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async ({page,search,startDate,endDate,sortOrder, limit ,gender}, { rejectWithValue }) => {
    try {
      const response = await getUsers(page,search,startDate,endDate,sortOrder,limit,gender);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Update a astrologer status
export const updateUserStatusAsync = createAsyncThunk(
  "astrologers/updateUserStatus",
  async ({ id, statusObj }, { rejectWithValue }) => {
    try {
      const response = await updateUserStatus(id, statusObj); // Now calling from userService.js
      toast.success(response.message || "Status updated successfully!");
      return { id, statusObj };
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);



const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Users
      .addCase(fetchUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload.data.users;
        state.total = action.payload.data.total;
        state.page = action.payload.data.page;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Update User Status
      .addCase(updateUserStatusAsync.fulfilled, (state, action) => {
        const {id,statusObj} = action.payload;

        if (!Array.isArray(state.users)) {
            return;
        }
        const index = state.users.findIndex((user) =>{
         return user._id === id
        });
        if (index !== -1) {
          state.users[index] = { ...state.users[index], ...statusObj };
        }
      })

  },
});

export const { clearError } = userSlice.actions;
export default userSlice.reducer;
